import {
  ISshDataConnectionContext,
  SshDataConnectionContext,
} from "@via/context/ssh-data-connection-context.tsx";
import { useContext } from "react";

export function useSshDataConnection(): ISshDataConnectionContext {
  return useContext(SshDataConnectionContext);
}
